import { ossDomains } from "@/config/domains";
import jiaopei from '@/config/sharedText/jiaopei';
import qipei from '@/config/sharedText/qipei';
import lodash from 'lodash';
import { defineStore } from 'pinia';
import yiliao from '../config/sharedText/yiliao';
import { useMenuStore } from './menu';


export const useBaseStore = defineStore("baseStore", {
  state: () => {
    return {
      baseUrl: "",
      instInfo: "",
      myProfile: "",
      userInfo: "",
      accessType: "",
      pageNumbers: {},
      addBookCheckedList: [],
      appHome: "",
      detailType: "",
      classId: "",
      courseToRecord: "",
      classDetailCourseData: "",
      courseData: "",
      appBackPhotoUrl:
        "https://cdnws.51tyty.com/lstyty/file/2021/12/30/2d0b3916a11ef8a2f2b9f1dab8c499a7.png",
      // 财务
      //意向学员数据用于转正,正式学员数据用于购课
      studentValue: {},
      //订单详情返回跳转路径
      orderDetailBack: "",
      //从学员管理调到任务详情，开侧弹窗
      opencustom:'',
      developEnv: 'preossm', // 开发环境
      isInternal: false, // 是否是内部机构true-是
      industryType: 1, //机构类型：1教培 2企培 3医疗
    };
  },
  getters: {
    apiDomain: state => {
      return state.baseDomain + "/api.php";
    },
    baseDomain: state => {
      if (process.env.NODE_ENV === "development") {
        const env = state.developEnv ? state.developEnv : 'preossm'
        return ossDomains[env]["OssBaseUrl"];
      } else {
        const host = location.host.split(".")[0];
        if (state.instInfo == "") {
          return ossDomains[host]["OssBaseUrl"];
        } else {
          return state.baseUrl.OssBaseDomain;
        }
      }
    },
    businessDomain: state => {
      if (process.env.NODE_ENV === "development") {
        const env = state.developEnv ? state.developEnv : 'preossm'
        return ossDomains[env]["BusinessUrl"];
      } else {
        const host = location.host.split(".")[0];
        return ossDomains[host]["BusinessUrl"];
      }
    },
    qwDomain: () => {
      // localhost下默认preossm.SCRMBaseUrl
      if (process.env.NODE_ENV === "development") return ossDomains['preossm']['QWBaseUrl']
      const host = location.host.split(".")[0]
      return ossDomains[host]['QWBaseUrl']
    },
    isZhihui: (state) => {
      return state.userInfo.inst_code == 'zhihui' ? 1 : 0
    },
    // 是否shuji账号
    isShuji: state => {
      return state.userInfo.inst_id == "1639" ? 1 : 0;
    },
    // 是否外教账号
    LSforeign: state => {
      if(state.userInfo.isForeignInst == 1){
        return true
      }
      return false
    }, 
    // 是否商学院
    isBusinessSchool: state => {
      let data = ["business_school", "sale", 'corporate_university'];
      return data.includes(state.instInfo.subject) ? 1 : 0;
    },
    courseSeriesType: (state) => {
      const menuStore = useMenuStore()
      const host = menuStore.hasOwnProperty("menuPath") && menuStore.menuPath ?menuStore.menuPath.includes('self_courses/series'):"";
      return host ? 'interestingReading' : 'seriesCourse'
    },
    // 文案区分
    getTexts: (state) => {
      if (state.instInfo.subject == 'business_school' || state.instInfo.subject == "corporate_university") {
        return qipei
      } else if (state.instInfo.subject == 'dentistry') {
        return yiliao
      } else {
        return jiaopei
      }
      // return state.instInfo.subject == 'business_school' || state.instInfo.subject == 'dentistry' ? qipei : jiaopei;
    },
    isMainCampusCourse: state => {
      return state.userInfo.mainCourseId == state.userInfo.inst_id ? 1 : 0;
    },
    // 是否为微信公众号付费
    isWeChatPay: state => {
      return state.instInfo.isTytyPayment == "true" ? 0 : 1;
    },
    // 是否公众号支付
    isOfficialAccountPay: state => {
      return state.instInfo.isTytyPayment == "true" ||
        state.instInfo.isInstPayment == "true"
        ? 1
        : 0;
    },
    // 套餐允许延期天数
    unpayDuration: state => {
      return state.instInfo.isTytyPayment == "true"
        ? state.instInfo.unpayDuration
        : "false";
    },
    // 角色
    isAllPermission: state => {
      if (state.userInfo.adminRole && state.userInfo.adminRole > 0) {
        return 2;
      } else {
        if (
          state.userInfo.role == "groupHeadTeacher" ||
          state.userInfo.role == "saler"
        ) {
          if (state.userInfo.role == "groupHeadTeacher") {
            return 1;
          } else {
            return 0;
          }
        } else {
          return 2;
        }
      }
    },
    isInformation: state => {
      let data = ["kssp", "hbwlgj", "ml20", "df123", "kula"];
      return data.includes(state.userInfo.mainCampusCode) ? 1 : 0;
    },
    schoolsAndCourses: state => {
      let list = [];
      if (state.myProfile == "") {
        list = [];
      } else {
        if (Array.isArray(state.myProfile.schoolsAndCourses)) {
          list = lodash.cloneDeep(state.myProfile.schoolsAndCourses);
        } else {
          list.push(lodash.cloneDeep(state.myProfile.schoolsAndCourses));
        }
      }
      return list;
    },
  },
  actions: {
    init(data) {
      this.baseUrl = data["baseUrl"];
      this.instInfo = data["instInfo"];
      this.myProfile = data["myProfile"];
      this.userInfo = data["userInfo"];
      localStorage.setItem("token", data["userInfo"].token);
      if(data.hasOwnProperty("userInfo") && data.userInfo.serverId && data.userInfo.userId) {
        const uniqueUserId = `${data.userInfo.serverId}_${data.userInfo.userId}`
        window.collectEvent && window.collectEvent('config', {user_unique_id: uniqueUserId});
      }
    },
    // 更新myprofile
    updateMyProfile(data) {
      this.myProfile = data;
    },
    // 数据中心
    setAccessType(data) {
      this.accessType = data;
    },
    // 单词词书
    updateAddBookCheckedList(v) {
      if (v) {
        const findResult = this.addBookCheckedList.find(item => {
          return item.index == v.index;
        });
        if (findResult) {
          findResult.data = v.data;
        } else {
          this.addBookCheckedList.push(v);
        }
      } else {
        this.addBookCheckedList = [];
      }
      //   state.addBookCheckedList = v;
    },
    handleAppBackPhotoUrl(data) {
      this.appBackPhotoUrl = data;
    },
    updateAppHome(data) {
      this.appHome = data;
    },
    // 数据中心周期切换
    setDCPDomain(data) {
      this.userInfo.domian = data;
    },
    updateDetailType(data) {
      this.detailType = data;
    },
    updateClassId(data) {
      this.classId = data;
    },
    updateCourseToRecord(data) {
      this.courseToRecord = data;
    },
    updateClassDetailCourseData(data) {
      this.classDetailCourseData = data;
    },
    updateCourseData(data) {
      this.courseData = data;
    },
    updateStudentValue(data) {
      this.studentValue = data;
    },
    updateOrderDetailBack(data) {
      this.orderDetailBack = data;
    },
    //设置新功能提示点击我知道后隐藏提示
    setStudentIsShow() {
      this.userInfo.studentIsShow = "2";
    },
    updateOpencustom(data){
      this.opencustom = data
    },
    setDevelopEnv(data) {
      this.developEnv = data
    },
    updateIsInternal(data){
      this.isInternal = data
    },
    updateIndustryType(data){
      this.industryType = data
    },
  },
  persist: {
    storage: sessionStorage,
    enabled: true
  }
});
